/**
 * Global LLM wait meter: ref-counted depth + optional promise wrapper.
 * No UI subscriber is currently mounted (the old global horizontal progress
 * bar was removed); `trackLlmWaitPromise` is still used by services because
 * other surfaces may subscribe in the future and the counter is cheap.
 */

/** Kept for backwards compat with any future progress UI. */
export const LLM_QUERY_PROGRESS_DURATION_MS = 60_000;

let waitDepth = 0;

/** @type {Set<(depth: number) => void>} */
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(waitDepth);
    } catch (e) {
      console.warn('[llmWaitIndicator] listener error', e);
    }
  });
}

export function subscribeLlmWaitIndicator(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getLlmWaitDepth() {
  return waitDepth;
}

export function beginLlmWait() {
  waitDepth += 1;
  emit();
}

export function endLlmWait() {
  if (waitDepth <= 0) return;
  waitDepth -= 1;
  emit();
}

/**
 * Show the global meter until `promise` settles (success or failure).
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<T>}
 */
export function trackLlmWaitPromise(promise) {
  beginLlmWait();
  return Promise.resolve(promise).finally(() => {
    endLlmWait();
  });
}
